import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, InputBase } from "@mui/material";
import { designSystem } from "app/theme";

const PulseInput = ({
  label,
  helperText,
  error,
  endAdornment,
  startAdornment,
  sx = {},
  ...inputProps
}) => {
  return (
    <Box sx={{ width: "100%", ...sx }}>
      {label && (
        <Typography
          variant="caption"
          sx={{
            color: error ? "#9F3E22" : "#a1a1aa", // Burnt Orange or Warm Stone
            textTransform: "uppercase",
            letterSpacing: "0.1em", // Wide tracking
            fontWeight: 500,
            fontFamily: "'Geist Mono', monospace",
            fontSize: "0.75rem",
            mb: 0.5,
            display: "block"
          }}
        >
          {label}
        </Typography>
      )}

      <Box
        sx={{
          display: "flex",
          alignItems: inputProps.multiline ? "flex-start" : "center",
          gap: 1,
          borderRadius: "8px",
          padding: "8px 14px",
          backgroundColor: "color-mix(in srgb, var(--text-primary) 4%, transparent)",
          border: error
            ? "1px solid rgba(159, 62, 34, 0.5)"
            : "1px solid color-mix(in srgb, var(--text-primary) 8%, transparent)",
          transition: "all 0.2s ease",
          "&:hover": {
            backgroundColor: "color-mix(in srgb, var(--text-primary) 6%, transparent)",
            borderColor: error ? "rgba(159, 62, 34, 0.5)" : "color-mix(in srgb, var(--text-primary) 15%, transparent)",
          },
          "&:focus-within": {
            backgroundColor: "color-mix(in srgb, var(--text-primary) 5%, transparent)",
            borderColor: error ? "rgba(159, 62, 34, 0.5)" : "color-mix(in srgb, var(--text-primary) 20%, transparent)",
          },
        }}
      >
        {startAdornment && (
          <Box sx={{ color: "#a1a1aa", mt: inputProps.multiline ? 0.5 : 0 }}>
            {startAdornment}
          </Box>
        )}
        <InputBase
          fullWidth
          {...inputProps}
          sx={{
            color: "var(--text-primary)",
            fontSize: "0.85rem",
            fontFamily: "'Inter', sans-serif",
            fontWeight: 400,
            "& input": {
              "&:-webkit-autofill": {
                transition: "background-color 5000s ease-in-out 0s",
                WebkitTextFillColor: "#f4f4f5 !important",
                caretColor: "#818cf8",
              },
            },
            "& textarea": {
                padding: 0,
            }
          }}
        />
        {endAdornment && (
          <Box sx={{ display: "flex", alignItems: "center", mt: inputProps.multiline ? 0.5 : 0, color: "#a1a1aa" }}>
            {endAdornment}
          </Box>
        )}
      </Box>

      {helperText && (
        <Typography
          variant="caption"
          sx={{
            mt: 0.5,
            color: error ? "#9F3E22" : "#78716c",
            fontWeight: 400,
            fontFamily: "'Geist', sans-serif"
          }}
        >
          {helperText}
        </Typography>
      )}
    </Box>
  );
};

PulseInput.propTypes = {
  label: PropTypes.string,
  helperText: PropTypes.string,
  error: PropTypes.bool,
  endAdornment: PropTypes.node,
  startAdornment: PropTypes.node,
  sx: PropTypes.object,
};

export default PulseInput;
